import React, { ReactNode } from 'react';
import { useFeatureFlagMatch } from '@/hooks/common/useFeatureFlag';
import type { FeatureFlagName, FeatureFlagWhen } from '@/hooks/common/useFeatureFlag';

interface FeatureGateProps {
  flag: FeatureFlagName;
  when?: FeatureFlagWhen;
  children: ReactNode;
  fallback?: ReactNode;
  loadingFallback?: ReactNode;
}

/**
 * Conditionally renders children based on a PostHog feature flag.
 * Renders nothing while PostHog is loading to avoid flashing
 * the wrong content in either direction.
 */
export const FeatureGate: React.FC<FeatureGateProps> = ({
  flag,
  when = 'enabled',
  children,
  fallback = null,
  loadingFallback = null,
}) => {
  const isMatch = useFeatureFlagMatch(flag, when);

  // PostHog still loading — render nothing (avoids flash)
  if (isMatch === null) return <>{loadingFallback}</>;

  if (!isMatch) return <>{fallback}</>;

  return <>{children}</>;
};
